import React, { useState, useEffect } from "react";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { cn } from "../../lib";

interface TimerProps {
  initialTime: string;
  maxResend: number;
  onResend: () => void;
}

const ICTimer: React.FC<TimerProps> = ({
  initialTime,
  maxResend,
  onResend,
}) => {
  // Utility function to parse time in "mm:ss" format
  const parseTime = (timeString: string): number => {
    const [minutes, seconds] = timeString.split(":").map(Number);
    return minutes * 60 + seconds;
  };
  const { t } = UseTranslationHook();
  // Utility function to format time as "mm:ss"
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  const [time, setTime] = useState(parseTime(initialTime));
  const [resendCount, setResendCount] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const handleResendClick = () => {
    if (resendCount < maxResend && time === 0) {
      onResend();
      setResendCount((prevCount) => prevCount + 1);
      setTime(parseTime(initialTime));
    }
  };

  return (
    <>
      {time !== 0 && (
        <div className="text-center mt-2 text-sm text-muted">
          {t("resend_in")} : {formatTime(time)}
        </div>
      )}

      {time === 0 && (
        <div
          className={cn(`text-center mt-2 flex`, {
            hidden: resendCount === maxResend,
          })}
        >
          <p>{t("did_not_send_otp")}</p>
          <p
            onClick={handleResendClick}
            className={cn(`text-accent ml-1`, {
              "cursor-pointer": time === 0,
            })}
          >
            {t("resend_otp")}
          </p>
        </div>
      )}
    </>
  );
};

export default ICTimer;
